// extracted by mini-css-extract-plugin
export var container = "CartItem-module--container--zpFds";
export var deletebtn = "CartItem-module--deletebtn--OFdsq";
export var description = "CartItem-module--description--Wimlc";
export var qty = "CartItem-module--qty--S2oYl";